import { css } from "@emotion/css";

import { Icon } from "../../foundations/icons/Icon/Icon";

export function VerifiedBadge() {
  return (
    <div
      className={css(styles.container, {
        backgroundColor: "var(--background-base)",
        boxShadow: "var(--shadow-base)",
      })}
      data-testId="verified-badge"
    >
      <Icon
        name="verified_user"
        type="mini"
        color="icon-success"
        padding="space-1"
        size="space-4"
      />
    </div>
  );
}

const styles = {
  container: css({
    position: "absolute",
    bottom: "0px",
    right: "0px",
    display: "flex",
    justifyItems: "center",
    borderRadius: "var(--border-radius-half)",
  }),
};
